<template>
  <div class="modal-container">
    <div class="modal-bg"></div>
     <slot name="terms"></slot>
    <div class="modal-content"><slot name="content"></slot></div>

  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
@Component
export default class BaseModal extends Vue {}
</script>

<style lang="scss" scoped>
.modal-container {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  .modal-bg {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: -1;
  }

  .modal-content {
    border-radius: 0.5rem;
    background-color: white;
        @include mix.responsive('xs') {
    width: 90%;
  }
  }
}
</style>
